// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"53bb6f6c","422":"ccfc4bee","464":"c88b2290"}[chunkId] + ".chunk.css";
};